var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemovePerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2809",
    "data-name": "Rectangle 2809",
    width: 30,
    height: 30,
    transform: "translate(310 610)",
    fill: "#ff8300",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Remove_Person",
    "data-name": "Remove Person",
    transform: "translate(-310 -610)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "person_remove_FILL0_wght400_GRAD0_opsz48",
    d: "M23.143,14.929V12.786h8.286v2.143ZM12.857,17.107A5.138,5.138,0,0,1,7.5,11.75a5.138,5.138,0,0,1,5.357-5.357,5.138,5.138,0,0,1,5.357,5.357,5.138,5.138,0,0,1-5.357,5.357ZM1.429,28.571V25.214a4.248,4.248,0,0,1,.625-2.268,3.784,3.784,0,0,1,1.8-1.518,27.37,27.37,0,0,1,4.768-1.661,18.761,18.761,0,0,1,4.232-.482,18.529,18.529,0,0,1,4.214.482,27.583,27.583,0,0,1,4.75,1.661,4.138,4.138,0,0,1,1.821,1.536,4.072,4.072,0,0,1,.643,2.25v3.357Zm2.143-2.143H22.143V25.214a2.034,2.034,0,0,0-.321-1.089,1.976,1.976,0,0,0-.857-.768A21.1,21.1,0,0,0,16.679,21.8a18.246,18.246,0,0,0-3.821-.375,18.5,18.5,0,0,0-3.839.375,20.955,20.955,0,0,0-4.3,1.554,1.87,1.87,0,0,0-.839.768,2.122,2.122,0,0,0-.3,1.089Zm9.286-11.464a3.115,3.115,0,0,0,3.214-3.214,3.115,3.115,0,0,0-3.214-3.214A3.115,3.115,0,0,0,9.643,11.75a3.115,3.115,0,0,0,3.214,3.214ZM12.857,11.75ZM12.857,26.429Z",
    transform: "translate(308.571 607.518)",
    fill: "#ff8300"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovePerson);
export default __webpack_public_path__ + "static/media/RemovePerson.5dd1eddcbd542f14777239971e0af307.svg";
export { ForwardRef as ReactComponent };